import routerOptions0 from "/builds/brighterly/apps/land-app/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vue+compiler-sfc@3.5.17_db0@0.3._a9eb51118a7ce069ab80d8e2f70a582f/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/brighterly/apps/land-app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}